import { Directive, ElementRef, Input, OnInit, OnChanges } from '@angular/core';
import { iconList } from '@pkg-framework/mediaData/iconList';

@Directive({
  selector: '[Icons]',
  standalone: true,
  host: {
    class: 'icon'
  }
})
export class IconsDirective implements OnInit, OnChanges {
  @Input() name = '';
  @Input() color: string = 'var(--text-color)';
  @Input() strokeWidth: number = 10;
  @Input() SVGclass: string = '';
  @Input() size: number = 50;
  list: Record<string, { type: string; path: string }> = iconList as any;

  constructor(private ref: ElementRef) {}

  load() {
    const currentElement = this.ref.nativeElement;
    const icon = this.list[this.name];
    if (icon) {
      const color = icon['type'] === 'mono' ? 'fill:' + this.color + ';' : '';
      const stroke = icon['type'] === 'mono' ? 'stroke:' + this.color + ';' : '';
      currentElement.innerHTML =
        '<span style="display: flex;justify-content: center;align-items: center;margin: 0;padding: 0;width:' +
        (this.size + 5) +
        'px; height:' +
        (this.size + 5) +
        'px;">' +
        '<svg xmlns="http://www.w3.org/2000/svg"  class="icon ' +
        this.SVGclass +
        '" ' +
        ' style="width: 100%; height: 100%;' +
        color +
        ' ' +
        stroke +
        '  stroke-width: ' +
        this.strokeWidth +
        'pt "' +
        ' viewBox="0 0 512 512">' +
        '<path d="' +
        icon.path +
        '"/>' +
        '</svg>' +
        '</span>';
    }
  }

  ngOnChanges(): void {
    this.load();
  }

  ngOnInit() {
    this.load();
  }
}
